export interface GoogleRecaptchaInterface {
  success: boolean;
  score?: number;
  action?: string;
  challenge_ts?: string;
  hostname?: string;
  "error-codes"?: string;
}

export class GoogleRecaptchaClass {
  success: boolean;

  score: number;

  action: string;

  challenge_ts: string;

  hostname: string;

  "error-codes": string;

  constructor(res: any) {
    this.success = res?.success ?? false;
    this.score = res?.score ?? 0;
    this.action = res?.action ?? "";
    this.challenge_ts = res?.challenge_ts ?? "";
    this.hostname = res?.hostname ?? "";
    this["error-codes"] = res["error-codes"] ?? "";
  }
}
